import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import IFireplace from '../../server/src/Interfaces/IFireplace'
import { MAX_FIREPLACES_PER_TYPE } from './fireplaceCount'

interface FireplaceCounterProps {
    fireplace: IFireplace
    count: number
    onChange: (count: number) => void
}

const FireplaceCounter: React.FC<FireplaceCounterProps> = ({ fireplace, count, onChange }) => (
    <div className="customer-fireplace-item">
        <span className="customer-fireplace-label">{fireplace.name}</span>
        <div className="customer-fireplace-stepper" role="group" aria-label={'Tulisijan ' + fireplace.name + ' lukumäärä'}>
            <button
                type="button"
                className="customer-fireplace-stepper-button"
                disabled={count <= 0}
                aria-label={'Vähennä tulisijan ' + fireplace.name + ' määrää'}
                onClick={() => onChange(count - 1)}
            >
                <FontAwesomeIcon icon={faMinus} />
            </button>
            <output className="customer-fireplace-stepper-count" aria-live="polite" aria-label={count + ' kappaletta'}>
                {count}
            </output>
            <button
                type="button"
                className="customer-fireplace-stepper-button"
                disabled={count >= MAX_FIREPLACES_PER_TYPE}
                aria-label={'Lisää tulisijan ' + fireplace.name + ' määrää'}
                onClick={() => onChange(count + 1)}
            >
                <FontAwesomeIcon icon={faPlus} />
            </button>
        </div>
    </div>
)

export default FireplaceCounter
